// extracted by mini-css-extract-plugin
export const sectionInfographic = "infographic-module--sectionInfographic--mw9Y5";
export const sectionContainer = "infographic-module--sectionContainer--3g1UP";
export const desktopWrapper = "infographic-module--desktopWrapper--ys2re";
export const mobileWrapper = "infographic-module--mobileWrapper--3HaoY";
export const contentCell = "infographic-module--contentCell--1vyyR";
export const featuredCell = "infographic-module--featuredCell--2XHaF";
export const mobileFeatures = "infographic-module--mobileFeatures--34Jpu";